"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _ViewAllFeatures = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/ViewAllFeatures"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      flex-direction: column;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &.bundle-flex {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      display: block;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: 8px;\n  ", "\n  .bundle-flex & {\n    display: none;\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BundleSubtitle = _styledComponents.default.div.withConfig({
  displayName: "HubBundleHeader__BundleSubtitle",
  componentId: "n774lr-0"
})(_templateObject(), _responsiveBreakpoints.default.phone(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()));

var StyledFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "HubBundleHeader__StyledFlex",
  componentId: "n774lr-1"
})(_templateObject4(), _responsiveBreakpoints.default.phone(_templateObject5()));

var HubBundleHeader = function HubBundleHeader(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      hub = _ref.hub,
      gaClassName = _ref.gaClassName,
      isNew = _ref.isNew;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledFlex, {
    className: "bundle-flex"
  }, _react.default.createElement("div", {
    className: "align-center"
  }, _react.default.createElement(_H.default, {
    className: "m-bottom-0"
  }, title), isNew && _react.default.createElement(_UIBadge.default, {
    use: "new",
    className: "m-left-3"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.new"
  }))), _react.default.createElement(BundleSubtitle, null, subtitle), _react.default.createElement("div", {
    className: "m-top-2 m-right-2 m-left-auto"
  }, _react.default.createElement(_ViewAllFeatures.default, {
    trackingPrefix: "bundle",
    hub: hub,
    use: "inline",
    gaClassName: (0, _publicPageUrls.getGAClassName)(gaClassName)
  }))), _react.default.createElement(BundleSubtitle, null, subtitle));
};

var _default = HubBundleHeader;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/HubBundleHeader.js
// module id = 251
// module chunks = 5 6